import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { AsyncSelect, SelectOption } from '@percent/lemonade'
import { OrganisationSelectProps } from './OrganisationSelect.types'

const MIN_SEARCH_LENGTH = 3

export function OrganisationSelect({
  name,
  setOrganisationValue,
  setQueryValue,
  countryCode,
  placeholder,
  query = '',
  organisation: selectedOrganisation,
  data,
  isLoading,
  onAddNonProfit,
}: OrganisationSelectProps) {
  const { t } = useTranslation()

  const selectOptions: SelectOption[] = useMemo(
    () =>
      data?.map((org) => ({
        value: org.id,
        label: org.name,
        description: [org.address, org.postcode].filter(Boolean).join(', '),
      })) ?? [],
    [data]
  )

  const onOptionSelected = (organisation: SelectOption | null) => {
    if (organisation) {
      setOrganisationValue(data?.find((org) => org.id === organisation?.value))
    }
  }

  return (
    <AsyncSelect
      name={name}
      key={countryCode}
      placeholder={placeholder}
      onChange={onOptionSelected}
      defaultValue={{
        value: selectedOrganisation?.id ?? '',
        label: selectedOrganisation?.name ?? '',
      }}
      options={selectOptions}
      setQuery={setQueryValue}
      query={selectedOrganisation?.name ?? query}
      loading={query.length > 0 && isLoading && !selectedOrganisation}
      data-testid="organisationSearch"
      minSearchLength={MIN_SEARCH_LENGTH}
      minSearchLengthMessage={t(
        'hostedValidation.typography.minSearchLengthMessage',
        { count: MIN_SEARCH_LENGTH }
      )}
      addOption={{
        label: t('hostedValidation.button.cantFindNonprofit'),
        onClick: () => onAddNonProfit(),
      }}
    />
  )
}
